<template>
  <div class="app">
      <div class="center">
        <el-card style="width:90%;margin-top:10px;padding:0px" class="card">
            <el-row style="height:2rem;border-bottom:1px solid #E4E7ED" class="vertical_center">
                <b style="color:#606266">{{$t('other.a87')}}</b><span style="font-size:14px">{{orderData.orderId}}</span>
                
                <span v-if="orderData.escrowAmount"><span class="header_type">{{$t('other.a584')}}：</span><span class="header_emphasize" >{{orderData.escrowAmount}}</span></span>

                <span ><span class="header_type">{{$t('other.a583')}}：</span><b class="header_emphasize" >{{getStatus(orderData)}}</b></span>
                <span v-if="!orderData.cod && orderData.platform=='SHOPEE'" ><span class="header_type">{{$t('other.a588')}}：</span><span class="header_normal" >{{getTime(orderData.createTime)}}</span></span>












                <span v-if="orderData.escrowAmount"><span class="header_type">{{$t('other.a1089')}}：</span><span class="header_normal" >{{getTime(orderData.createTime)}}</span></span>
            </el-row>


            <el-row>
                
            </el-row>

        </el-card>
      </div>
  </div>
</template>
<script>
import utils from '../../../utils/utils.js'

export default {
    name:'orderCard',
    props: {
        orderData: {
            type: Object,
            default:()=>{},
        },
    },

computed:{


 
},

watch:{
  

  

},

created(){

},
mounted(){
   

},
methods:{
  getStatus(item){
    let ttp=utils.conversionStatus(item)
    return ttp
  },
    getTime(item){
        return utils.renderTime(item)
    },
}
}

</script>
<style lang="scss" scoped>
.center{
    display: flex;
    justify-content: center;
    align-items:center;
}
.vertical_center{
    display: flex;
    align-items:center;
}
.top{
    margin-top: 20px;
}
.right{
    float: right;
}
.left{
    float: left;
}
.title{
    color: #606266;
    font-size: 20px;
    overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
    width: 400px;
    text-align:left;
}

.p{
    text-indent: 2em;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
}

.author{
    font-size: 14px;
    color: #909399;
}
/deep/.el-card__body{
    padding: 0px;
}
.header_type{
    margin-left: 1rem;
    font-size: 14px;
    color: #606266;
}
.header_emphasize{
    color:#F56C6C;
    font-size: 14px;
}
.header_normal{
    font-size: 14px;
}




</style>

